/**
 * Vue
 * @type {Vue | VueConstructor}
 */
import Vue from 'vue';
import './filters/globalFilters.js';
import {notifyMixin} from './mixins/notify';
import {formMixin} from './mixins/form';
import {dynamicContentMixin} from './mixins/dynamicContent';
import {openAnchorTabMixin} from './mixins/openAnchorTab';
import WsTest from './components/WsTest';
import DataTable from './components/Datatable/Table';
import Signature from './components/Signature/Analysis';
import TransactionEditor from './components/Transaction/Editor';
import FolderViewer from './components/FolderViewer/Viewer';

/**
 * Set Global Vue
 */
window.Vue = Vue;

/**
 * App
 * @constructor
 */
window.Lagina = new Vue({
  el: '#app',

  mixins: [
    notifyMixin,
    formMixin,
    dynamicContentMixin,
    openAnchorTabMixin,
  ],

  components: {
    'ws-test': WsTest,
    'data-table': DataTable,
    'signature': Signature,
    'transactionEditor': TransactionEditor,
    'folderViewer': FolderViewer
  },

  computed: {
    locale() {
      return window.locale;
    },
  }, // end computed

  mounted() {
    $(() => {
      Lagina.initJQueryPlugins();
    });
  }, // end mounted

  methods: {
    initJQueryPlugins() {
      // Confirmation dialog.
      $("[data-confirm]").on('click', function () {
        const label = $(this).data('confirm') || this.trans('Devam etmek istediğinize emin misiniz?');
        return confirm(label);
      });

      // Bootstrap Tooltip
      $('[data-toggle="tooltip"]').tooltip();

      // Select2
      if (jQuery().select2) {
        $('[data-select2-init]').each(function () {
          const $el = $(this);

          $el.select2({
            allowClear: $el.attr('allow-clear') || true,
            minimumResultsForSearch: 3,
            placeholder: {
              id: $el.attr('placeholder-key') || $el.data('placeholder-key') || '',
              text: $el.attr('placeholder') || $el.data('placeholder') || '...'
            }
          })
        });
      }

      // Inputmask plugin
      Lagina.maskInputs();
    }, // end initJQueryPlugins

    maskInputs() {
      if (!jQuery().inputmask) {
        return;
      }

      $("[data-inputmask]").inputmask({
        rightAlign: false,
        autoUnmask: true,
      });

      $(".form-numeric").inputmask({
        rightAlign: false,
        autoUnmask: true,
        alias: 'numeric',
      });
    }, // end maskInputs
  }, // end methods
});
